import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Classificação de Não Conformidade',
    path: '/nao-conformidade/ncoclassificacao',
    name: 'ncoclassificacao',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/nco-classificacao/Index.vue'),
    meta: {
      permissions: [EPermissoes.NaoConformidade_Configuracao],
      escopoObra: 'global'
    }
  },
  {
    description: 'Cadastro de Classificação de Não Conformidade',
    path: '/nao-conformidade/nco-classificacao/cadastro',
    parent: 'ncoclassificacao',
    name: 'ncoclassificacao-insert',
    component: () => import('@/views/nao-conformidade/nco-classificacao/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ncoclassificacao',
      onlyAdmin: true
    }
  },
  {
    description: 'Edição de Classificação de Não Conformidade',
    path: '/nao-conformidade/nco-classificacao/cadastro/:id',
    parent: 'ncoclassificacao',
    name: 'ncoclassificacao-update',
    component: () => import('@/views/nao-conformidade/nco-classificacao/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ncoclassificacao',
      onlyAdmin: true
    }
  }
];
